// src/pages/FAQ.js
import React, { useState } from "react";

const faqs = [
  {
    question: "What is PreciseDraft.ai?",
    answer:
      "A B2B personalization platform. We turn live buying signals into proof-backed, 1:1 messages written in your voice—and run them as governed, omnichannel campaigns (LinkedIn messaging, Apollo exports, CRM/CDP sync)."
  },
  {
    question: "How does PreciseDraft.ai enable personalized marketing?",
    answer:
      "We detect real triggers (e.g., releases, integrations, pricing/package changes, security posts, hiring spikes), compile a brief with receipts (link + dated screenshot), and craft role-aware notes for Engineering, Finance, and Operations with a single, relevant ask."
  },
  {
    question: "What are the advantages of personalized marketing versus conventional outreach?",
    answer:
      "Low-volume, high-intent, and auditable. Instead of templated blasts, we send only when a material signal exists, tailor the message to each role, and multi-thread the buying committee—driving higher reply quality and cleaner pipeline."
  },
  {
    question: "Do you support automated campaigns?",
    answer:
      "Yes. Full automations with steps, timing, and rules across channels. For LinkedIn, you can generate up to 20 connection messages at a time in a bulk composer—each personalized with tokens/receipts—and schedule sends with pacing that respects platform limits. You can import lead lists exported from Apollo (CSV) to personalize and send messages here. Email is supported via Apollo exports, and CRM/CDP integrations (e.g., HubSpot, Salesforce, Segment) keep statuses in sync."
  },
  {
    question: "Can you enrich leads if I don’t have valid emails?",
    answer:
      "Yes. We can run B2B enrichment to discover updated work emails and phone numbers for the leads you provide. Results aren’t guaranteed but we try to return validated emails from multiple searches . Catch-all domains are treated as invalid and excluded from campaigns. We verify via MX/DNS/SMTP and partner checks and return statuses (Verified, Risky, Catch-all, Invalid). By default, only Verified records move forward and compliance rules are applied."
  },
  {
    question: "What metrics do I get?",
    answer:
      "Delivery & engagement: deliveries, bounces, spam complaints, opens, clicks, replies.\nQuality: Positive Interest Rate (PIR), Threading Success (% accounts with ≥2 roles engaged), Time-to-Positive/POC.\nOperations: domain health score (DHS), warmup/ramp status, suppression events."
  },
  {
    question: "What are your Quality Gates?",
    answer:
      "Each message must include a verified receipt, pass a Personalization Quality Score (PQS) threshold, meet role-fit and Voicebook rules, and clear uniqueness/blocked-phrase checks. No-signal/No-send is enforced, and you can approve with evidence before launch."
  },
  {
    question: "How do you handle compliance and deliverability?",
    answer:
      "Built-in CAN-SPAM/CASL/GDPR controls (identification, unsubscribe/opt-out syncing, list provenance). We manage DKIM/SPF/DMARC checks, domain warmup and pacing, frequency caps, suppression, and reputation monitoring. While no platform can guarantee inbox placement, our spam-risk filters and DHS guardrails (auto-pause below thresholds) materially improve deliverability."
  },
  {
    question: "Do you filter spam and protect sender reputation?",
    answer:
      "Yes. We run spam-risk heuristics, monitor complaint/bounce rates, and enforce DHS guardrails. Anomalies trigger throttling or auto-pauses, and abusers are removed to protect the ecosystem and all customers’ reputation."
  },
  {
    question: "Is my data secure with PreciseDraft.ai?",
    answer:
      "Yes. Encryption in transit and at rest, role-based access, audit trails, least-privilege services, and clear retention/deletion controls. We minimize PII and support regional data choices where applicable."
  }
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">
        Frequently Asked Questions
      </h1>
      <div className="max-w-3xl mx-auto">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4">
            <button
              className="w-full text-left bg-gray-100 px-6 py-4 rounded-md flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-lg font-medium text-gray-800">
                {faq.question}
              </span>
              <span className="ml-4 text-xl font-bold text-gray-600">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="mt-2 bg-white px-6 py-4 border border-t-0 border-gray-200 rounded-b-md">
                <p className="text-gray-700 whitespace-pre-line">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
